// composables/useDBConnectionError.ts
import { ref } from "vue";

// valores globais compartilhados através da closure
const visible = ref(false);

export function useDBConnectionError() {
	function show() {
		visible.value = true;
	}
	function hide() {
		visible.value = false;
	}

	return { visible, show, hide };
}
